import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { DadosConciliacao } from '../models/dados-conciliacao';
import { ConciliacaoApiService } from '../services/conciliacao-api.service';
import { ReconciliarLancamentosRequest } from '../models/reconciliar-lancamentos-request';


@Injectable()
export class ReconciliarLancamentosAntigosResolver implements Resolve<DadosConciliacao> {

  constructor(
    private conciliacaoApiService: ConciliacaoApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<DadosConciliacao> {
    const { contaBancoId, dataInicio, dataFim } = router.queryParams;

    if (!contaBancoId || !dataInicio || !dataFim) {
      throw new Error('Parâmetros obrigatórios não informados');
    }
    
    const request = new ReconciliarLancamentosRequest(
      contaBancoId, dataInicio, dataFim
    );

    const conciliacao: Observable<DadosConciliacao> = this.conciliacaoApiService.reconciliarLancamentosAntigos(request);

    return zip(conciliacao).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}